import React, { Component } from 'react';
import { SiteSideMenuContainer, SiteSideMenuWrapper, SiteSideMenuOverlay } from './styles/index';

class SiteSideMenu extends Component {
  render() {
    const { closeSideMenu, children, isFromInterview, isDashboard } = this.props;

    return (
      <SiteSideMenuContainer>
        <SiteSideMenuOverlay isDashboard={isDashboard} onClick={() => closeSideMenu()} />
        <SiteSideMenuWrapper isDashboard={isDashboard} isFromInterview={isFromInterview}>
          {children}
        </SiteSideMenuWrapper>
      </SiteSideMenuContainer>
    );
  }
}

export default SiteSideMenu;
